import { DTO } from "./dto.js";

export class CarreraBasicaDTO extends DTO {
    constructor() {
        super();
        this.resolucion = "";
        this.nombre = "";
    }

    cargarDTO(dto) {
        super.cargarDTO(dto);

        if (dto.resolucion !== undefined) { this.resolucion = dto.resolucion; }
        if (dto.nombre !== undefined) { this.nombre = dto.nombre; }
    }

    clone(dto) {
        super.clone(dto);

        dto.resolucion = this.resolucion;
        dto.nombre = this.nombre;
    }
}
